import { connect } from 'react-redux';
import get from 'lodash/get';
import { isUuid } from '../../../js/app/react/validators';
import View from './DebtManagementWorkflowView';
import { WORKFLOW_ID } from './DebtManagementWorkflowConstants';
import {
  reloadAdvizrApplication,
  endOfWorkflowsRedirectTo,
} from '../AdvWorkflow/AdvWorkflowHelpers';
import { shouldSkipSummarySelector } from '../AdvWorkflow/AdvWorkflowSelector';
import { getGoalPageName } from '../../FinancialPlanOPL/Goals/utils/getGoalPageName';
import { GoalTypeDTO } from '../../FinancialPlanOPL/types/goalsDTO';

const mapStateToProps = (state, ownProps) => ({
  workflowId: WORKFLOW_ID,
  shouldSkipSummary: shouldSkipSummarySelector(state, ownProps),
});

const mapDispatchToProps = () => ({
  outputFunction: clientId => response => {
    const { ADV } = window;
    reloadAdvizrApplication(true, false, () => {
      const currentClient = ADV.util.getCurrentClient(ADV.data);

      const outputRoute =
        currentClient.ComponentName || getGoalPageName(GoalTypeDTO.DebtManagement);

      const goalId = get(response, 'payload.viewData.Goals.Id', null);
      if (!isUuid(goalId)) {
        throw new Error("'payload.viewData.Goals.Id' must be an uuid.");
      }

      const params = {
        clientId,
        goalId,
      };
      endOfWorkflowsRedirectTo(outputRoute, params);
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
